import {Mutation} from './mutation-types'
import {showWarning} from "../utils";
export default {
    [Mutation.CREATE_ORDER_STATE] (state, orderReference) {
        return state.orderReferences.push(orderReference)
    },
    [Mutation.CREATE_HISTORY] (state, history) {
        return state.history.push(history)
    },
    [Mutation.CREATE_DECOMPOSED_HISTORY] (state, {orderReferenceHistory, stationHistories , machineHistories} ) {
        if(!orderReferenceHistory || !stationHistories.length || !machineHistories.length )
            return showWarning(`Insuficientes datos para crear historial`,
                {
                    HistorialLinea:         orderReferenceHistory,
                    HistorialesEstaciones:  stationHistories,
                    HistorialesEquipos:     machineHistories
                })
    },
    [Mutation.CREATE_ORDER_STATE] (state, orderState) {
        return state.orderStates.push(orderState)
    },
    [Mutation.CREATE_ACTIVE_MODAL] (state, {modal, data}) {
        let foundModalIndex = state.activeModals.findIndex(m => m.modal === modal)
        if(foundModalIndex !== -1)
            return showWarning('Ya existe el modal que intenta mostrar')
        return state.activeModals.push({
            modal, data
        })
    },
    [Mutation.UPDATE_ACTIVE_MODAL] (state, {modal, data}) {
        let foundModalIndex = state.activeModals.findIndex(m => m.modal === modal)
        if(foundModalIndex === -1)
            return showWarning(`Este modal no existe (${modal})`)

        return state.activeModals[foundModalIndex] = {
            ...state.activeModals[foundModalIndex],
            ...{modal, data}
        }
    },
    [Mutation.DELETE_ACTIVE_MODAL] (state, {modal, data}) {
        let modalIndex = state.activeModals.findIndex(m => m.modal === modal)
        if(modalIndex === -1)
            return showWarning(`El modal que intenta ocultar no esta activo (${modal})`)
        state.activeModals = state.activeModals.filter(m => m.modal !== modal);
        return state.activeModals
    },

    //KANBAN
    [Mutation.CREATE_KANBAN] (state, kanban) {

        state.tempKanban = kanban.map(p => ({
            id:p.id,
            name: p.name,
            orderReferenceInProduction: p.orderReferenceInProduction,
            orderReferencesFinished: p.orderReferencesFinished,
            orderReferencesQueued: p.orderReferencesQueued
        }))

        state.kanban = kanban
        return state.kanban;
    },

    // KANBAN ORDER REFERENCE
    [Mutation.CREATE_KANBAN_ORDER_REFERENCE] (state, { kanbanOrderReference, onQueue, productionLineId, index }) {
        if (!kanbanOrderReference) {
            showWarning('Línea de pedido no válida');
            return;
        }
        let productionLine = state.kanban.find(pl => pl.id == (productionLineId ?? kanbanOrderReference.production_line_id));
        if (onQueue) {
            productionLine?.orderReferencesQueued.splice(index, 0, kanbanOrderReference);
            return; // Se termina aquí porque no hay más acciones necesarias
        }
        switch (kanbanOrderReference.order_state_id) {
            case 1: // Pedidos pendientes
                state.kanbanPendingOrderReferences.splice(index, 0, kanbanOrderReference);
                break;
            case 2: // Pedido en producción
                if (productionLine) {
                    productionLine.orderReferenceInProduction = kanbanOrderReference;
                }
                break;
            case 3: // Pedidos finalizados
                productionLine?.orderReferencesFinished.splice(index, 0, kanbanOrderReference);
                break;
        }
        if (productionLine) {
            const indexPL = state.kanban.findIndex(pl => pl.id == productionLine.id);
            if (indexPL !== -1) {
                state.kanban[indexPL] = productionLine;
            }
        }
    },
    [Mutation.UPDATE_KANBAN_ORDER_REFERENCE] (state, kanbanOrderReference) {},
    [Mutation.DELETE_KANBAN_ORDER_REFERENCE] (state, {kanbanOrderReference, onQueue,productionLineId}) {
        if(!kanbanOrderReference) {
            showWarning('Linea de pedido no valida')
            return false;
        }
        let productionLine = null;
        if(productionLineId != 0) productionLine = state.kanban.find(pl => pl.id == productionLineId)

        if(!onQueue){
            state.kanban.forEach(pl =>{
                let idx = state.kanbanPendingOrderReferences.findIndex(o => o.id == kanbanOrderReference.id);
                if(idx != -1){
                    productionLine = pl;
                }
            })
        }


        if(onQueue){
            productionLine.orderReferencesQueued.splice(
                productionLine.orderReferencesQueued.findIndex(o => o.id == kanbanOrderReference.id), 1
            );
        }else {
            switch(kanbanOrderReference.order_state_id){
                case 1:
                    state.kanbanPendingOrderReferences.splice(
                        state.kanbanPendingOrderReferences.findIndex(o => o.id == kanbanOrderReference.id), 1
                    );
                    break;
                case 2: productionLine.orderReferenceInProduction = null;
                    break;
                case 3: productionLine.orderReferencesFinished.splice(
                    productionLine.orderReferencesFinished.findIndex(o => o.id == kanbanOrderReference.id), 1
                ); break;
            }
        }

        state.kanban[state.kanban.findIndex(pl => pl.id == productionLine.id)] = productionLine;
        return state.kanban;
    },
    [Mutation.ORDER_KANBAN_ORDER_REFERENCES] (state, {kanbanOrderReferences, onQueue, productionLineId}) {
        if(productionLineId){
            let productionLine = state.kanban.find(pl => pl.id == productionLineId);
            if(Array.isArray(kanbanOrderReferences) && kanbanOrderReferences.length > 0){
                if(onQueue){
                    productionLine.orderReferencesQueued = kanbanOrderReferences
                }else{
                    switch(kanbanOrderReferences[0].order_state_id){
                        case 1: state.kanbanPendingOrderReferences = kanbanOrderReferences;
                        break;
                        case 2: productionLine.orderReferenceInProduction = kanbanOrderReferences[0];
                        break;
                        case 3: productionLine.orderReferencesFinished = kanbanOrderReferences;
                        break;
                    }
                }
                state.kanban[state.kanban.findIndex(pl => pl.id == productionLine.id)] = productionLine;
                return state.kanban;
            }
        }
    },

    // KANBAN PENDING LIST

    [Mutation.CREATE_KANBAN_PENDING_LIST] (state, kanbanPendingList){
        if(!kanbanPendingList)
            return showWarning('Lista de ordenes requerida')

        state.kanbanPendingOrderReferences = kanbanPendingList;
        return state.kanbanPendingOrderReferences;
    },

    // CALENDAR
    [Mutation.CREATE_CALENDAR] (state, calendar) {
        state.calendar = calendar
        return state.calendar;
    },
    // CALENDAR EVENTS
    [Mutation.CREATE_CALENDAR_EVENT] (state, calendarEvent) {
        //Error si el evento no es valido
        if(!calendarEvent || !calendarEvent.hasOwnProperty('id')){
            showWarning('No se puede añadir el evento')
            return false;
        }

        //Error si ya existe
        var index = state.calendarEvents.findIndex(e => e.id == calendarEvent.id);
        if(index != -1){
            showWarning(`Este evento ya existe (id ${calendarEvent.id})`)
            return false;
        }

        state.calendarEvents.push(calendarEvent)
        return state.calendarEvents;
    },
    [Mutation.UPDATE_CALENDAR_EVENT] (state, calendarEvent) {
        if(!calendarEvent || !calendarEvent.hasOwnProperty('id')){
            return showWarning('No se puede añadir el evento')
        }
        var calendarEventToUpdateIndex = state.calendarEvents.findIndex(c => c.id == calendarEvent.id);
        if(!calendarEventToUpdateIndex){
            return showWarning('Calendario no existente, imposible editar')
        }

        state.calendarEvents.splice(calendarEventToUpdateIndex, 1, calendarEvent);
        return state.calendarEvents;
    },
    [Mutation.DELETE_CALENDAR_EVENT] (state, calendarEventId) {
        if(!calendarEventId) {
            return showWarning('Id no valido, imposible eliminar')
        }

        state.calendarEvents.splice(state.calendarEvents.findIndex(c => c.id == calendarEventId), 1)
        return state.calendarEvents;
    },
    [Mutation.DELETE_ALL_CALENDAR_EVENTS] (state) {
        state.calendarEvents = [];
    },
    [Mutation.DELETE_ORDER_REFERENCE_CALENDAR_EVENTS](state) {
        state.calendarEvents = state.calendarEvents.filter(event => !event.id.startsWith("order-reference-"));
    },
    [Mutation.ADD_CALENDAR_EVENTS](state, events) {
        state.calendarEvents.push(...events);
    },
    [Mutation.UPDATE_FILTER] (state, filter) {
        if(!filter)
            return showWarning('Filtro no valido')
        state[filter.name] = filter.value
        return state[filter.name];
    },
    [Mutation.DELETE_FILTER] (state, filterName) {
        if(!state.hasOwnProperty(filterName))
            return showWarning('Filtro no existente, imposible borrar')
        delete state[filterName];
        return state;
    },

    // LAST UPDATE TIME
    [Mutation.SET_LAST_UPDATE_TIME] (state, lastUpdateTime) {
        if(!lastUpdateTime || typeof  lastUpdateTime != 'string')
            return showWarning('Tiempo invalido')

        state.lastUpdateTime = lastUpdateTime;
        return state.lastUpdateTime;
    },

    // QUEUE EDIT ACTIVE
    [Mutation.SET_QUEUE_EDIT_ACTIVE] (state, queueEditActive) {
        if(!['number','string'].includes(typeof queueEditActive))
            return showWarning('Tipo no convertible en booleano')
        state.queueEditActive = ['1', 'true', 1].includes(queueEditActive);
        return state.queueEditActive;
    },

    // KANBAN CONTAINER OVERLAY
    [Mutation.SET_SHOW_KANBAN_CONTAINER_OVERLAY] (state, showKanbanContainerOverlay) {
        if(!['boolean'].includes(typeof showKanbanContainerOverlay))
            return showWarning('Tipo no convertible en booleano')
        state.showKanbanContainerOverlay = showKanbanContainerOverlay;
        return state.showKanbanContainerOverlay;
    },

    // MENU SHOWING
    [Mutation.SET_IS_MENU_SHOWING] (state, isMenuShowing) {
        if(!['boolean'].includes(typeof isMenuShowing))
            return showWarning('Tipo no convertible en booleano')
        state.isMenuShowing = isMenuShowing;
        return state.isMenuShowing;
    },
}
